import { format, isValid } from 'date-fns';

export function formatPayoutTraceCreatedDate(value: string | Date | null | undefined): string | undefined {
  if (value == null || value === '') {
    return undefined;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (!isValid(date)) {
    return undefined;
  }
  return format(date, 'dd/MM/yyyy');
}
